import * as React from "react";

export function ArrowCircleDown(props) {
  return (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function ArrowCircleLeft(props) {
  return (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function ArrowCircleRight(props) {
  return (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function ArrowCircleUp(props) {
  return (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function Back({ size = 6 }) {
  return (
    <svg
      className={`w-${size} h-${size}`}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" />
    </svg>
  );
}

export function Collection({ size = 6 }) {
  return (
    <svg
      className={`w-${size} h-${size}`}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zm-2 4a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
    </svg>
  );
}

export function Down({ size = 4 }) {
  return (
    <svg
      className={`w-${size} h-${size}`}
      fill="currentColor"
      viewBox="0 0 341.333 341.333"
    >
      <polygon points="311.253,140.587 192,259.627 192,0 149.333,0 149.333,259.627 30.293,140.373 0,170.667 170.667,341.333 341.333,170.667" />
    </svg>
  );
}

export function Eye({ size = 6 }) {
  return (
    <svg
      className={`w-${size} h-${size}`}
      fill="currentColor"
      viewBox="0 0 469.333 469.333"
    >
      <path d="M234.667,170.667c-35.307,0-64,28.693-64,64s28.693,64,64,64s64-28.693,64-64S269.973,170.667,234.667,170.667z" />
      <path d="M234.667,74.667C128,74.667,36.907,141.013,0,234.667c36.907,93.653,128,160,234.667,160 c106.773,0,197.76-66.347,234.667-160C432.427,141.013,341.44,74.667,234.667,74.667z M234.667,341.333 c-58.88,0-106.667-47.787-106.667-106.667S175.787,128,234.667,128s106.667,47.787,106.667,106.667 S293.547,341.333,234.667,341.333z" />
    </svg>
  );
}

export function Next({ size = 6 }) {
  return (
    <svg
      className={`w-${size} h-${size}`}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" />
    </svg>
  );
}

export function Pen({ size = 6 }) {
  return (
    <svg
      className={`w-${size} h-${size}`}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zm-2.207 2.207L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
    </svg>
  );
}

export function Rubbish({ size = 6 }) {
  return (
    <svg
      className={`w-${size} h-${size}`}
      fill="currentColor"
      viewBox="0 0 384 384"
    >
      <path d="M64,341.333C64,364.8,83.2,384,106.667,384h170.667C300.8,384,320,364.8,320,341.333v-256H64V341.333z M116.587,189.44 l30.187-30.187L192,204.48l45.227-45.227l30.187,30.187l-45.227,45.227l45.227,45.227l-30.187,30.187L192,264.853l-45.227,45.227 l-30.187-30.187l45.227-45.227L116.587,189.44z" />
      <polygon points="266.667,21.333 245.333,0 138.667,0 117.333,21.333 42.667,21.333 42.667,64 341.333,64 341.333,21.333" />
    </svg>
  );
}

export function Up({ size = 4 }) {
  return (
    <svg
      className={`w-${size} h-${size}`}
      fill="currentColor"
      viewBox="0 0 341.333 341.333"
    >
      <polygon points="170.667,0 0,170.667 30.187,200.853 149.333,81.707 149.333,341.333 192,341.333 192,81.707 311.147,200.853 341.333,170.667" />
    </svg>
  );
}

export function VideoCamera({ size = 6 }) {
  return (
    <svg
      className={`w-${size} h-${size}`}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm12.553 1.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
    </svg>
  );
}

export function XCircle({ size = 6 }) {
  return (
    <svg
      className={`w-${size} h-${size}`}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
        clipRule="evenodd"
      />
    </svg>
  );
}
